/**
 * Money as Shopify sent it.
 *
 * Amounts arrive as STRINGS and the store takes several currencies — the live order list has GBP
 * alongside USD — so the currency is never assumed and never dropped. `Intl` formats it when the
 * code is known; anything it rejects falls back to "amount CODE" rather than a bare number, which
 * would read as dollars.
 *
 * Shared by the orders table and the order card so a total cannot be formatted one way in the list
 * and another way in the drawer.
 */
export function formatMoney(
  amount?: string | null,
  currency?: string | null,
): string {
  if (!amount) return "—";
  if (!currency) return amount;
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
    }).format(Number(amount));
  } catch {
    return `${amount} ${currency}`;
  }
}
